<template>
    <div id="app">
        <link rel="stylesheet"
              href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css">
        <!--
      <nav>
          <li><router-link to='/'><a>IntroPage</a></router-link></li>
          <li><router-link to='/currentschool'><a>CurrentSchool</a></router-link></li>
          <router-view/>
     </nav>
     -->
        <router-view/>
        <div style="padding-top: 2em;">
        </div>
    </div>
</template>

<script>
    export default {
        name: 'app',
        data() {
            return {
                store: this.$store
            }
        },
        components: {},
        methods: {},
        beforeCreate() {
        },
        mounted: function () {
        }
    }
</script>

<style lang="scss">
    @import "styles/appBody.scss";
</style>
